import type { TFunction, TOptions } from 'i18next';

export const translateOptions = (
  options: { value: string; label: string }[],
  t: TFunction,
  tParams: TOptions = {},
) =>
  options.map((option) => ({
    value: option.value,
    label: t(option.label, tParams) as string,
  }));
